<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>测序公司管理</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="0">
            <el-form :inline="true" :model="seqCompany" class="demo-form-inline" size="mini" @submit.native.prevent>
                <el-form-item label="测序公司">
                    <el-input v-model="seqCompany.condition.value" placeholder="测序公司" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="querySeqCompany" @keyup.enter.native="enterQuery">查询</el-button>
                    <el-button type="primary" size="mini" @click="toAddRegion">新增</el-button>
                </el-form-item>
            </el-form>
            <el-table
            :data="seqCompanys"
            :height="tableHeight"
            size="mini"
            border
            ref="tb"
            style="width: 100%">
                <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="companyName" label="测序公司"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="toUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10,20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog title="新增测序公司" :visible.sync="dialogFormVisible"  append-to-body>
            <el-form :model="addSeqCompany" ref="addForm" size="mini" :rules="rules" label-width="120px" @submit.native.prevent>
                <el-form-item label="测序公司" prop="companyName">
                    <el-input v-model="addSeqCompany.companyName" clearable></el-input>
                </el-form-item>
                <el-row type="flex" style="justify-content: right;">
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="submit('addForm')">提交</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>
        <el-dialog title="修改测序公司" :visible.sync="updateDialog"  append-to-body>
            <el-form :model="updateSeqCompany" ref="updateForm" size="mini" :rules="rules" label-width="120px" @submit.native.prevent>
                <el-form-item label="测序公司" prop="companyName">
                    <el-input v-model="updateSeqCompany.companyName" clearable></el-input>
                </el-form-item>
                <el-row type="flex" style="justify-content: right;">
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="submitUpdate('updateForm')">提交</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
    
</template>

<script>

    export default {
        name:'WelcomeSet',
        data() {
            return {
                seqCompany: {
                    condition:{
                    },
                    pageNum: 1,
                    pageSize:0
                },
                direction: 'rtl',
                seqCompanys: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                tableHeight: "",//表格高度
                tableHeight1: "",//表格高度
                tableHeight2: "",//表格高度
                dialogFormVisible: false,
                addSeqCompany:{},
                updateDialog: false,
                updateSeqCompany: {},
                selectedRegion: {},
                roles: [],
                rules: {
                    companyName: [
                        { required: true, message: "请输入公司名称", trigger: "blur" }
                    ]
                },
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.querySeqCompany();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querySeqCompany();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.querySeqCompany();
                })
                .catch(() => {});
            },
            querySeqCompany() {
                this.seqCompany.pageNum = this.currentPage;
                this.seqCompany.pageSize = this.pageSize;
                this.$axios.post("/seqCompany/find",this.seqCompany).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.seqCompanys = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
                this.tableHeight1 = this.tableHeight/2;
                this.tableHeight2 = this.tableHeight/2 - 10;
            },
            toggleSelection(rows) {
                if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
                } else {
                this.$refs.multipleTable.clearSelection();
                }
            },
            toAddRegion() {
                this.dialogFormVisible = true;
                this.addSeqCompany = {};
            },
            
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/seqCompany/save",this.addSeqCompany).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message.info(res.data.message);
                                this.dialogFormVisible = false;
                                this.querySeqCompany();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                } else {
                    return false;
                }
                });
            },
            submitUpdate() {
                this.$axios.post("/seqCompany/save",this.updateSeqCompany).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message.info(res.data.message);
                            this.updateDialog = false;
                            this.querySeqCompany();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            toUpdate(row) {
                this.updateSeqCompany = row;
                this.updateDialog = true;
            },
            del(row) {
                this.$confirm('您确认删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post("/seqCompany/delete",row).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.querySeqCompany();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            enterQuery(){
                document.onkeydown =(e) => {
                    e = window.event || e;
                    if(this.$route.path=='/home/seqCompany'&&(e.code=='Enter'||e.code=='enter')){
                        //调用查询方法
                        this.querySeqCompany();
                        return;
                    }
                }
            },
        },
        mounted() {
            this.querySeqCompany();
        },
        created() {
            this.getTableHeight();
            this.enterQuery();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

</style>
